const statusNumber = [
  'Waiting',
  'Ready to Implement',
  'Technical Impediment',
  'Under Development',
  'Implemented',
];

export { statusNumber };
